
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/showBlog",
      function () {
        return require("private-next-pages/showBlog/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/showBlog"])
      });
    }
  